@if (showPage) {
  <div class="background">
    <div class="sign-on-panel" nz-row nzAlign="middle" nzJustify="space-around">
      <nz-card class="sign-in-panel" nzTitle="SRIMS - Sign In">
        @if (user$ | async; as user) {
          @if (!user.uid) {
            <nz-tabs nzType="card">
              <nz-tab nzTitle="CityU Staff/Student">
                <div class="sign-in-tab">
                  <a [attr.href]="ssoUrl" nz-button nzType="primary">
                    CityU Web Sign On
                  </a>
                </div>
              </nz-tab>
              <nz-tab nzTitle="Other Users">
                <div class="sign-in-tab">
                  <form [formGroup]="form" class="login-form">
                    <nz-form-item>
                      <nz-form-label [nzSm]="8" [nzXs]="24" nzRequired>User ID</nz-form-label>
                      <nz-form-control [nzSm]="16" [nzXs]="24">
                        <input formControlName="userId" nz-input type="text"/>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                      <nz-form-label [nzSm]="8" [nzXs]="24" nzRequired>Password</nz-form-label>
                      <nz-form-control [nzSm]="16" [nzXs]="24">
                        <input formControlName="password" nz-input type="password"/>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item nz-row>
                      <nz-form-control [nzOffset]="8" [nzSpan]="16">
                        <button (click)="signIn()" nz-button nzType="primary">Sign In</button>
                      </nz-form-control>
                    </nz-form-item>
                  </form>
                </div>
              </nz-tab>
            </nz-tabs>
          } @else {
            <div>
              <p>You are already logged in to the system.</p>
              <div>
                <a [routerLink]="'/welcome'" nz-button nzType="primary">
                  Continue
                </a>&nbsp;
                <a (click)="signOut()" nz-button nzType="primary">
                  Sign Out
                </a>
              </div>
            </div>
          }
        }
      </nz-card>
    </div>
  </div>
}
